export { default } from './detail-container.component';
